<template>
  <div class="calendar-entry c-notification p-4"
       :class="color">
    <h4 class="c-notification-header">
      {{ header }}
    </h4>

    <p class="c-notification-body">
      {{ body }}
    </p>
  </div>
</template>

<script>
export default {
  name: "AllocationUser",
  props: {
    color: String,
    header: String,
    body: String,
  },
};
</script>

<style lang="scss" scoped>
.c-notification {
  text-align: left;
  display: flex;
  flex-direction: column;

  .c-notification-header {
    font-size: 1.25rem;
  }
  .c-notification-body {
    font-size: 1rem;
  }
}
</style>